import React from "react";

import { IconProps } from "../../../primitive";
import { AxeIcon } from "../icons/AxeIcon";
import { BasketballIcon } from "../icons/BasketballIcon";
import { BocceBallIcon } from "../icons/BocceBallIcon";
import { BusinessIcon } from "../icons/BusinessIcon";
import { CroquetIcon } from "../icons/CroquetIcon";
import { DiningIcon } from "../icons/DiningIcon";
import { HockeyIcon } from "../icons/HockeyIcon";
import { RacquetsIcon } from "../icons/RacquetsIcon";
import { ShuffleboardIcon } from "../icons/ShuffleboardIcon";
import { SpaIcon } from "../icons/SpaIcon";
import { AquaticsIcon } from "./../icons/AquaticsIcon";
import { BoatingIcon } from "./../icons/BoatingIcon";
import { CardRoomIcon } from "./../icons/CardRoomIcon";
import { ClubIcon } from "./../icons/ClubIcon";
import { FitnessIcon } from "./../icons/FitnessIcon";
import { GolfIcon } from "./../icons/GolfIcon";
import { SalonIcon } from "./../icons/SalonIcon";

export type DepartmentType =
  | "AQUATICS"
  | "BASKETBALL"
  | "BOATING"
  | "BUSINESS"
  | "CARD_ROOM"
  | "CLUB"
  | "CROQUET"
  | "DINING"
  | "FITNESS"
  | "GOLF"
  | "RACQUET"
  | "SALON"
  | "SPA"
  | "AXE_THROWING"
  | "BOCCE_BALL"
  | "HOCKEY"
  | "SHUFFLEBOARD";

export const DepartmentIcon = ({
  type,
  iconProps,
}: {
  type: DepartmentType;
  iconProps?: IconProps;
}) => {
  const IconComponent = getDepartmentIconComponent(type || "");
  const defaultTitle = type
    .toLowerCase()
    .replace(/_/g, " ")
    .replace(/\b\w/g, (c) => c.toUpperCase());

  return (
    <IconComponent width={16} height={16} title={defaultTitle} {...iconProps} />
  );
};

function getDepartmentIconComponent(type: string) {
  switch (type) {
    case "RACQUET":
      return RacquetsIcon;
    case "SALON":
      return SalonIcon;
    case "BASKETBALL":
      return BasketballIcon;
    case "GOLF":
      return GolfIcon;
    case "BOATING":
      return BoatingIcon;
    case "AQUATICS":
      return AquaticsIcon;
    case "CARD_ROOM":
      return CardRoomIcon;
    case "FITNESS":
      return FitnessIcon;
    case "DINING":
      return DiningIcon;
    case "SPA":
      return SpaIcon;
    case "CLUB":
      return ClubIcon;
    case "BUSINESS":
      return BusinessIcon;
    case "CROQUET":
      return CroquetIcon;
    case "AXE_THROWING":
      return AxeIcon;
    case "BOCCE_BALL":
      return BocceBallIcon;
    case "HOCKEY":
      return HockeyIcon;
    case "SHUFFLEBOARD":
      return ShuffleboardIcon;
    default:
      return GolfIcon;
  }
}

export default DepartmentIcon;
